var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckCircleOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.22266C13.1527 3.22266 14.2944 3.4495 15.3594 3.89062C16.4242 4.33175 17.392 4.97796 18.207 5.79297C19.022 6.60798 19.6683 7.57578 20.1094 8.64062C20.5505 9.70559 20.7773 10.8473 20.7773 12C20.7773 13.1527 20.5505 14.2944 20.1094 15.3594C19.6683 16.4242 19.022 17.392 18.207 18.207C17.392 19.022 16.4242 19.6683 15.3594 20.1094C14.2944 20.5505 13.1527 20.7773 12 20.7773C9.67199 20.7773 7.43912 19.8532 5.79297 18.207C4.14682 16.5609 3.22266 14.328 3.22266 12C3.22266 9.67199 4.14682 7.43912 5.79297 5.79297C7.43912 4.14682 9.67199 3.22266 12 3.22266Z",
    fill: "#16BAB6",
    stroke: "#16BAB6",
    strokeWidth: 0.444444
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84375 11.9961L10.8687 14.0211L15.1437 9.74609",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircleOn);
export default __webpack_public_path__ + "static/media/icon_check_circle_on.9975de8d.svg";
export { ForwardRef as ReactComponent };